import type { StringDict } from "@/i18n/ui";

/** Blog listing and article shell copy (Editorial.tsx / ArticleParts.tsx). */
const dict: StringDict = {
  "min read": "Min. Lesezeit",
  Read: "Lesen",
  "Article topics": "Artikelthemen",
  "All topics": "Alle Themen",
  "Hide topics": "Themen ausblenden",
  "More topics": "Weitere Themen",
  Categories: "Kategorien",
  "Topics A–M": "Themen A–M",
  "Topics N–Z": "Themen N–Z",
  Newsletter: "Newsletter",
  "New articles, straight to your inbox": "Neue Artikel direkt in Ihr Postfach",
  "A short round-up of new Catuik articles, case studies and practical partner-marketing guides. No spam, unsubscribe at any time.":
    "Ein kurzer Überblick über neue Catuik-Artikel, Case Studies und praxisnahe Leitfäden zum Partnermarketing. Kein Spam, jederzeit abbestellbar.",
  "Thank you — you are subscribed. Look out for the next Catuik round-up.":
    "Vielen Dank — Ihre Anmeldung ist bestätigt. Freuen Sie sich auf den nächsten Catuik-Überblick.",
  Email: "E-Mail",
  Subscribe: "Abonnieren",
  "Continue reading": "Weiterlesen",
  "Useful materials on this topic": "Nützliche Materialien zu diesem Thema",
  "Useful on this topic": "Nützlich zu diesem Thema",
  "Free resource": "Kostenlose Ressource",
  "Common questions": "Häufige Fragen",
  "Written by": "Verfasst von",
  "editorial team": "Redaktionsteam",
  "Partner marketing specialists at Catuik by Admitad, working with brands, marketplace sellers, creators and agencies across Europe and Central Asia.":
    "Spezialistinnen und Spezialisten für Partnermarketing bei Catuik by Admitad — für Marken, Marktplatz-Händler, Creator und Agenturen in Europa und Zentralasien.",
  "Close promotion": "Hinweis schließen",
  resource: "Ressource",
  "Link copied": "Link kopiert",
  Share: "Teilen",
};

export default dict;
